const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const classNames = require('classnames');
const { formatValue } = require('../utilities/valueFormater');
import VerticalAccordion, {
    Row,
    Expandable,
} from 'components/commons/VerticalAccordion';

const RiskProfitTable = ({
    className,
    data: riskStatistics,
    onRowClick,
    selected,
}) => (
    <VerticalAccordion
        className={classNames('risk-profit-table', className)}
        selectedIndex={selected}
    >
        <Row onClick={() => onRowClick(0)}>
            <div className="flexible-table">
                <div className="flexible-table__row">
                    <div className="flexible-table__thead">
                        <h4 className="flexible-table__row__header">
                            {formatText('fundsCard-sharpeRatiosTitle')}
                        </h4>
                    </div>
                    <div className="flexible-table__tbody">
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year1').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics &&
                                riskStatistics.sharpeRatios &&
                                riskStatistics.sharpeRatios.some(
                                    rs => rs.timePeriod === 'M12',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.sharpeRatios.find(
                                                  rs => rs.timePeriod === 'M12',
                                              ).value,
                                          ),
                                      )}`
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year3').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics &&
                                riskStatistics.sharpeRatios &&
                                riskStatistics.sharpeRatios.some(
                                    rs => rs.timePeriod === 'M36',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.sharpeRatios.find(
                                                  rs => rs.timePeriod === 'M36',
                                              ).value,
                                          ),
                                      )}`
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year5').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics &&
                                riskStatistics.sharpeRatios &&
                                riskStatistics.sharpeRatios.some(
                                    rs => rs.timePeriod === 'M60',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.sharpeRatios.find(
                                                  rs => rs.timePeriod === 'M60',
                                              ).value,
                                          ),
                                      )}`
                                    : '-'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <Expandable viewIndex={0}>
            <div className="accordion--content">
                <h4>{formatText('fundsCard-sharpeRatiosTitle')}</h4>
                <div>{formatText('fundsCard-sharpeRatiosDescription')}</div>
            </div>
        </Expandable>
        <Row onClick={() => onRowClick(1)}>
            <div className="flexible-table">
                <div className="flexible-table__row">
                    <div className="flexible-table__thead">
                        <h4 className="flexible-table__row__header">
                            {formatText('fundsCard-volatilityTitle')}
                        </h4>
                    </div>
                    <div className="flexible-table__tbody">
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year1').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.standardDeviations.some(
                                    rs => rs.timePeriod === 'M12',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.standardDeviations.find(
                                                  rs => rs.timePeriod === 'M12',
                                              ).value,
                                          ),
                                      )}%`
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year3').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.standardDeviations.some(
                                    rs => rs.timePeriod === 'M36',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.standardDeviations.find(
                                                  rs => rs.timePeriod === 'M36',
                                              ).value,
                                          ),
                                      )}%`
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year5').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.standardDeviations.some(
                                    rs => rs.timePeriod === 'M60',
                                )
                                    ? `${formatValue(
                                          Number(
                                              riskStatistics.standardDeviations.find(
                                                  rs => rs.timePeriod === 'M60',
                                              ).value,
                                          ),
                                      )}%`
                                    : '-'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <Expandable viewIndex={1}>
            <div className="accordion--content">
                <h4>{formatText('fundsCard-volatilityTitle')}</h4>
                <div>{formatText('fundsCard-volatilityDescription')}</div>
            </div>
        </Expandable>
        <Row onClick={() => onRowClick(2)}>
            <div className="flexible-table">
                <div className="flexible-table__row">
                    <div className="flexible-table__thead">
                        <h4 className="flexible-table__row__header">
                            {formatText('fundsCard-positiveMonthsTitle')}
                        </h4>
                    </div>
                    <div className="flexible-table__tbody">
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year1').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfPositives.some(
                                    rs => rs.timePeriod === 'M12',
                                )
                                    ? riskStatistics.numberOfPositives.find(
                                          rs => rs.timePeriod === 'M12',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year3').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfPositives.some(
                                    rs => rs.timePeriod === 'M36',
                                )
                                    ? riskStatistics.numberOfPositives.find(
                                          rs => rs.timePeriod === 'M36',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year5').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfPositives.some(
                                    rs => rs.timePeriod === 'M60',
                                )
                                    ? riskStatistics.numberOfPositives.find(
                                          rs => rs.timePeriod === 'M60',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <Expandable viewIndex={2}>
            <div className="accordion--content">
                <h4>{formatText('fundsCard-positiveMonthsTitle')}</h4>
                <div>{formatText('fundsCard-positiveMonthsDescription')}</div>
            </div>
        </Expandable>
        <Row onClick={() => onRowClick(3)}>
            <div className="flexible-table flexible-table__last">
                <div className="flexible-table__row">
                    <div className="flexible-table__thead">
                        <h4 className="flexible-table__row__header">
                            {formatText('fundsCard-negativeMonthsTitle')}
                        </h4>
                    </div>
                    <div className="flexible-table__tbody">
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year1').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfNegatives.some(
                                    rs => rs.timePeriod === 'M12',
                                )
                                    ? riskStatistics.numberOfNegatives.find(
                                          rs => rs.timePeriod === 'M12',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year3').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfNegatives.some(
                                    rs => rs.timePeriod === 'M36',
                                )
                                    ? riskStatistics.numberOfNegatives.find(
                                          rs => rs.timePeriod === 'M36',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                        <div className="flexible-table__row__cell">
                            <span className="flexible-table__row__cell__title">
                                {formatText('fundsCard-year5').toUpperCase()}
                            </span>
                            <span className="flexible-table__row__cell__content">
                                {riskStatistics.numberOfNegatives.some(
                                    rs => rs.timePeriod === 'M36',
                                )
                                    ? riskStatistics.numberOfNegatives.find(
                                          rs => rs.timePeriod === 'M36',
                                      ).count
                                    : '-'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <Expandable viewIndex={3}>
            <div className="accordion--content">
                <h4>{formatText('fundsCard-negativeMonthsTitle')}</h4>
                <div>{formatText('fundsCard-negativeMonthsDescription')}</div>
            </div>
        </Expandable>
    </VerticalAccordion>
);

RiskProfitTable.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired,
    onRowClick: PropTypes.func,
    selected: PropTypes.number,
};

module.exports = RiskProfitTable;
